<template>
	<v-container class="ma-0 pa-0 steps_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="start" class="steps_title_descript">
				<p class="steps_count">3/8</p>
				<p>
					지금까지 평생<br />
					총 <span class="steps_bolder_words">담배 5갑</span>이상<br/>
					(100개비)피운적이 있으신가요?
				</p>
			</v-col>
		</v-row>
		<v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="center" align="center" class="avatar">
				<img
					:src="getAvatarImage"
					class="avatar-img"
					alt="아바타"
				>
			</v-col>
			<v-col cols="12" align-self="center" align="center">
				<button
					class="img-cell"
					tabindex="1"
					:class="smkStatType === 1 ? 'selected' : ''"
					@click="select(1)"
				>
					<img
						:src="getImage(1)"
						class="icon-img"
						alt="피운적 없음"
					/>
					<br/>
					피운적 없음
				</button>
				<button
					class="img-cell"
					tabindex="2"
					:class="smkStatType === 2 ? 'selected' : ''"
					@click="select(2)"
				>
					<img
						:src="getImage(2)"
						class="icon-img"
						alt="끊었음"
					/>
					<br/>
					끊었음
				</button>
				<button
					class="img-cell"
					tabindex="3"
					:class="smkStatType === 3 ? 'selected' : ''"
					@click="select(3)"
				>
					<img
						:src="getImage(3)"
						class="icon-img"
						alt="피우고 있음"
					>
					<br/>
					피우고 있음
				</button>
			</v-col>
		</v-row>

        <v-container class="pa-0 ma-0 mt-10 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
	data: () => ({
		enableButton: true,
		smkStatType: 1,
		smkTerm: "", // 흡연 기간 1~99년
		smkQty: "", // 하루 흡연량 1~99개비
	}),
	computed: {
		...mapGetters("survey", {
			checkUp: "checkUp"
		}),
		getAvatarImage() {
			switch(this.smkStatType) {
				case 1: return require('@/assets/images/avatar-pressure-normal.png')
				case 2: return require('@/assets/images/avatar-smoked.png')
				case 3: return require('@/assets/images/avatar-smoking.png')
				default: return require('@/assets/images/avatar-pressure-normal.png')
			}
		}
	},
	methods: {
		...mapActions("survey", ["setCheckupTemp", "setStep"]),
		getImage(selected) {
			if(this.smkStatType === selected) {
				switch(selected) {
					case 1: return require('@/assets/images/ico-smoke-never-s.png')
					case 2: return require('@/assets/images/ico-smoke-stop-s.png')
					case 3: return require('@/assets/images/ico-smoke-ing-s.png')
				}
			}
			else {
				switch(selected) {
					case 1: return require('@/assets/images/ico-smoke-never-n.png')
					case 2: return require('@/assets/images/ico-smoke-stop-n.png')
					case 3: return require('@/assets/images/ico-smoke-ing-n.png')
				}
			}
		},
		select(id) {
            this.smkStatType = id;
		},
		buttonChange() {
			this.enableButton = this.smkStatType != "";
		},
		previous() {
			this.setStep(5)
			this.$router.push("/checkup/step5")
		},
		next() {
			const params = {
				step: 6,
                smkStatType: this.smkStatType,
                smkTerm: this.smkTerm,
                smkQty: this.smkQty
			};
			this.setCheckupTemp(params);

			if (this.smkStatType == "1") {
				this.setStep(7)
				this.$router.push("/checkup/step7");
			} else {
				this.setStep(6)
				this.$router.push("/checkup/step61");
			}
		},
		restoreData() {
			if (this.checkUp.smkStatType) {
				this.smkStatType = this.checkUp.smkStatType;
			}
		}
	},
	watch: {
		smkStatType: function() {
			this.buttonChange();
		}
	},
	mounted() {
		window.scrollTo(0, 0)
		this.setStep(6)
		this.restoreData()
	}
};
</script>

<style scoped>
    .title {
        min-height: 25vh;
    }
	.avatar {
		text-align: center;
    }
    .avatar-img {
        width: 94px;
    }
	.option-wrapper {
        text-align: center;
        margin-bottom: 3vh;
	}
	.img-cell {
		display: inline-block;
		background-color: transparent;
		width: 90px;
        padding: 3vw 2vw;
		text-align: center;
		border-radius: 15px;
		vertical-align: middle;
		color: #8f8f8f;
		font-weight: normal;
        font-size: 16px;
	}
	.img-cell.selected {
		background-color: #3f6fff;
		color: white;
		font-weight: bold;
	}
	.icon-img {
		display: inline-block;
		height: 5vh;
	}

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }
</style>
